/* ============
 * Getters for the patient module
 * ============
 *
 * The getters that are available on the
 * patient module.
 */
import { clone } from '@/utils/object';

const getPatientList = state => clone(state.patientList);
const getPatient = state => clone(state.patient);
const getLoading = state => clone(state.loading);
const getTotalCount = state => clone(state.totalCount);
const getPatientStatusCount = (status) => {
  const patienStatusCount = clone(status.patienStatusCount);
  return patienStatusCount && patienStatusCount.sort((a, b) => {
    if (a.status < b.status) { return -1; }
    if (a.status > b.status) { return 1; }
    return 0;
  });
};
const getPatientEhrLoading = state => state.isPatientEhrLoading;
const getPatientListloading = state => state.isPatientListloading;

export default {
  getPatientList,
  getPatient,
  getLoading,
  getTotalCount,
  getPatientStatusCount,
  getPatientEhrLoading,
  getPatientListloading
};
